
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.45 14.829v1.423l-3.562 1.099C5.998 17.896 6 21.709 6 21.709S7.616 23 13.336 23s7.335-1.291 7.335-1.291c.007-1.213 0-3.813-1.887-4.358 0 0-2.996-.914-3.541-1.099v-1.423","stroke":"#4B62C1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.53 15.066c1.66-.712 1.825-2.633 2.015-4.104.094-.807.118-1.66-.261-2.396-.355-.665-.995-1.139-1.706-1.376A4.186 4.186 0 0013.345 7c-.426 0-.853.071-1.232.214-.71.237-1.35.711-1.706 1.375-.38.736-.356 1.59-.26 2.397.189 1.447.355 3.368 2.014 4.08","stroke":"#4B62C1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.212 10.321c2.37 0 2.844-.475 3.08-1.186 0 0 0 1.186 1.186 1.186","stroke":"#4B62C1","stroke-miterlimit":"10","stroke-linecap":"square","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.45 16.252c0 1.423 1.895 2.61 1.895 2.61s1.896-1.187 1.896-2.61","stroke":"#4B62C1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.53 7h-5.06c-.26 0-.47.216-.47.483v5.396c0 .107.127.162.201.085l1.334-1.372h3.994c.26 0 .471-.216.471-.484V7.483A.477.477 0 0024.53 7z","stroke":"#4B62C1","stroke-miterlimit":"10","stroke-linecap":"square","stroke-linejoin":"round"}})])
          )
        }
      }
    